import { axiosApi as axiosHelper } from '../helpers/axiosApi';
import { toaster } from '../helpers/toaster';
import { getCookie } from './helpers';
import axios from 'axios'

const getStudyList = (params) => {
  return axiosHelper.get("/studies/studies/", { params: params }).then(res => {
    return res.data;
  })
}

const getStudy = (uid) => {
  return axiosHelper.get("/studies/studies/" + uid + "/", {
    headers: {
      "Authorization": `Bearer ${getCookie('access')}`
    }
  }).then(res => {
    return res.data.data;
  })
}
const getStudiesByStatus = () => {
  return axiosHelper.get("/studies/studies/get_studies_by_status/", {
    headers: {
      "Authorization": `Bearer ${getCookie('access')}`
    }
  }).then(res => {
    return res.data;
  })
}

const getRecentStudies = () => {
  return axiosHelper.get("/studies/studies/get_recent_studies/", {
    headers: {
      "Authorization": `Bearer ${getCookie('access')}`
    }
  }).then(res => {
    return res.data;
  })
}

const getCount = () => {
  return axiosHelper.get("/studies/studies/get_count/", {
    headers: {
      "Authorization": `Bearer ${getCookie('access')}`
    }
  }).then(res => {
    return res.data;
  })
}

const addStudy = (org_study_id, elasticid) => {
  let payload = {
    org_study_id,
    elasticid,
    info: {}
  };

  return axiosHelper.post("/studies/studies/", payload, {
    headers: {
      "Authorization": `Bearer ${getCookie('access')}`
    }
  }).then(res => {
    return res.data;
  })
}

const updateStudy = async (id, data) => {
  try {
    const res = await axiosHelper.put(`/studies/studies/${id}/`, data, {
      headers: {
        "Authorization": `Bearer ${getCookie('access')}`
      }
    })
    return {
      status: res.status,
      data: res.data.data,
      statusText: res.statusText,
    }
  } catch (err) {
    toaster("Failed to update study: " + err, "error")
    console.log('updateStudy ERROR', err)
    return {
      status: err.request.status,
      statusText: err.request.statusText,
      message: err.message,
    }
  }
}

const deleteStudy = (id) => {
  return axiosHelper.delete("/studies/studies/" + id + "/", {
    headers: {
      "Authorization": `Bearer ${getCookie('access')}`
    }
  }).then(res => {
    return res.data;
  })
}

const updateBool = (id, field, boolValue) => {
  let payload = {
    id: id
  };
  payload[field] = boolValue;
  return axiosHelper.patch("/studies/studies/update_bool_field/", payload, {
    headers: {
      "Authorization": `Bearer ${getCookie('access')}`
    }
  }).then(res => {
    return res;
  })
}

const getStudyExport = () => {
  return axiosHelper.get("/studies/export/").then(res => res.data.data);
}

const getSimpleStudyList = () => {
  return axiosHelper.get("/studies/studies-simple/").then(res => res.data.data);
}

const syncSingleStudy = (id) => {
  return axiosHelper.get(`/studies/studies/${id}/sync_study_from_connex/`);
}

const exportStudyData = () => {
  return axiosHelper.get('studies/studies/export_data/', { responseType: 'blob' });
}

const triggerReport = (reportType) => {
  return axiosHelper.post('/studies/reports/trigger/', { report_type: reportType }).then(res => res.data);
}

const getReportTaskStatus = (taskId) => {
  return axiosHelper.get(`/studies/reports/tasks/${taskId}/`).then(res => res.data);
}


const searchCTGStudy = (id) => {
  let query = {
    query: {
      "bool": {
        "should": [
          // { "term": { "ctg_data.id_info.nct_id.keyword": id }},
          // { "term": { "ctg_data.org_study_id.keyword": id }},
          { "match": { "ctg_data.org_study_id.keyword": id } },
          { "match": { "ctg_data.id_info.nct_id.keyword": id } },
          // { "ctg_data.org_study_id": id }
        ]
      }
    }
  }
  return axiosHelper.post(`studies/search/study/_search/`,
    query,
    {
      "headers": {
        "content-type": "application/json",
      }
    },

  ).then(res => {
    if (res.status === 200) {
      return res.data.hits.hits
    }
  })
    .catch((err) => {
      if (!err.response)
        return;
      return err.response.data;
    });
}

const getSingleCTGStudy = (id) => {
  let query = {
    query: {
      "match": { "ctg_data.id_info.nct_id.keyword": id }
    }
  }
  return axiosHelper.post(`studies/search/study/_search/`,
    query,
    {
      "headers": {
        "content-type": "application/json",
      }
    },

  ).then(res => {
    if (res.status === 200) {
      return res.data.hits.hits[0]._source;
    }
  })
    .catch((err) => {
      if (!err.response)
        return;
      return err.response.data.errors[0];
    });
}
const getCTGStudies = ({ size, search, offset }) => {
  let query = { query: { "match_all": {} } }
  if (search) {
    query["query"] = {
      "bool": {
        "should": [
          {
            "wildcard": {
              "ctg_data.id_info.org_study_id": {
                "value": `*${search}*`,
                // "value":  `["*${search}*|*${search.toLowerCase()}*]"`,
                "boost": 1.0,
                // "case_insensitive": true
              }
            },

          },
          {
            "wildcard": {
              "ctg_data.id_info.nct_id.raw": {
                "value": `*${search}*`,
                // "value":  `["*${search}*|*${search.toLowerCase()}*]"`,
                "boost": 1.0,
                // "case_insensitive": true
              }
            },

          },
        {
            "wildcard": {
              "ctg_data.id_info.org_study_id": {
                "value": `*${search.toLowerCase()}*`,
                // "value":  `["*${search}*|*${search.toLowerCase()}*]"`,
                "boost": 1.0,
                // "case_insensitive": true
              }
            },

          },
          {
            "wildcard": {
              "ctg_data.id_info.nct_id.raw": {
                "value": `*${search.toLowerCase()}*`,
                // "value":  `["*${search}*|*${search.toLowerCase()}*]"`,
                "boost": 1.0,
                // "case_insensitive": true
              }
            },
          },
          {
            "wildcard": {
              "ctg_data.id_info.org_study_id": {
                "value": `*${search.toUpperCase()}*`,
                // "value":  `["*${search}*|*${search.toLowerCase()}*]"`,
                "boost": 1.0,
                // "case_insensitive": true
              }
            },

          },
          {
            "wildcard": {
              "ctg_data.id_info.nct_id.raw": {
                "value": `*${search.toUpperCase()}*`,
                // "value":  `["*${search}*|*${search.toLowerCase()}*]"`,
                "boost": 1.0,
                // "case_insensitive": true
              }
            },
          },
        ],
        "minimum_should_match": 1,
        "boost": 1.0
      }
    }
  }

  if (size) {
    query["size"] = size
  }
  else {
    query["size"] = 100
  }
  if (offset) {
    query["from"] = offset
  }
  return axiosHelper.post(`studies/search/study/_search/`,
    query,
    {
      "headers": {
        "content-type": "application/json",
      }
    },

  ).then(res => {
    if (res.status === 200) {
      return res.data;
    }
  })
    .catch((err) => {
      if (!err.response)
        return;
      return err.response.data.errors[0];
    });
}

export {
  getStudyList,
  getStudy,
  addStudy,
  updateStudy,
  deleteStudy,
  updateBool,
  getSimpleStudyList,
  syncSingleStudy,
  exportStudyData,
  getStudiesByStatus,
  getRecentStudies,
  getCount,
  getCTGStudies,
  getSingleCTGStudy,
  searchCTGStudy,
  getStudyExport,
  triggerReport,
  getReportTaskStatus,
}